import React from 'react'
import ReactDOM from 'react-dom/client'
import './index.css'
import ReactPixel from 'react-facebook-pixel'

const pixelId = '1550540542208866'

const MyComponent = React.lazy(() => import('./App'))

ReactPixel.init(pixelId)
ReactPixel.pageView()

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
        <MyComponent />
    </React.StrictMode>
)
